<script lang="ts">
	import { getGlobalSettings } from "../getGlobalSettings.js";

	const { GOOGLE_ANALYTICS, CLARITY, META_PIXEL } = getGlobalSettings();

	const trackingCookieScriptCategory = "targeting" satisfies CookieScriptCategory;

	export function revokeCookies(): void {
		window.clarity("consent", false);
		window.fbq("consent", "revoke");
	}

	export function acceptCookies(): void {
		window.clarity("consent", true);
		window.fbq("consent", "grant");
	}

	function processState(): void {
		const state = CookieScript.instance.currentState();
		if (state.action === "accept" && state.categories.includes(trackingCookieScriptCategory)) {
			acceptCookies();
		} else {
			revokeCookies();
		}
	}

	$: {
		if (typeof window !== "undefined") {
			window.addEventListener("CookieScriptAccept", (e) => {
				if (e.detail.categories.includes(trackingCookieScriptCategory)) {
					acceptCookies();
				} else {
					revokeCookies();
				}
			});

			window.addEventListener("CookieScriptReject", () => {
				revokeCookies();
			});
		}
	}

	$: {
		if (typeof window !== "undefined") {
			if (window.CookieScript?.instance) {
				processState();
			} else {
				window.addEventListener("CookieScriptLoaded", processState);
			}
		}
	}

	/* eslint-disable */
</script>

<svelte:head>
	{@html `<script async src="https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ANALYTICS}"></script>`}
	{@html `
	<script>
		window.dataLayer ||= [];
		function gtag(){window.dataLayer.push(arguments);}
		gtag('js', new Date());
		gtag('config', '${GOOGLE_ANALYTICS}');
	</script>
	`}
	{@html `<script>!function(f,b,e,v,n,t,s)
		{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
		n.callMethod.apply(n,arguments):n.queue.push(arguments)};
		if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
		n.queue=[];t=b.createElement(e);t.async=!0;
		t.src=v;s=b.getElementsByTagName(e)[0];
		s.parentNode.insertBefore(t,s)}(window, document,'script',
		'https://connect.facebook.net/en_US/fbevents.js');
		fbq('init', '${META_PIXEL}');
		fbq('track', 'PageView')</script>`}
	{@html `<script>(function(c,l,a,r,i,t,y){
		c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
		t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
		y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
		})(window, document, "clarity", "script", "${CLARITY}");
	</script>`}
</svelte:head>
